module.exports = __webpack_public_path__ + "media/images/client/facebook_image-8e513e3a96b5e489dac7757733ba3a29.png";